export const containerBoxStyles = { position: 'relative' }

export const progressCircleContainerStylesNoCentered = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
}

export const progressCircleContainerStylesCentered = {
  ...progressCircleContainerStylesNoCentered,
  alignItems: 'center',
}

export const progressCircleStyles = { 'svg circle': { stroke: 'url(#mth_loading_gradient)' } }
